import { ApiResult, HttpClient } from "../http.js";
import { KlsEquipmentDto, KlsEquipmentType, KlsEquipmentStatus } from "../types/kls-equipment.js";

export interface CreateKlsEquipmentPayload {
  name: string;
  type: KlsEquipmentType;
  manufacturer?: string | null;
  model?: string | null;
  serialNumber?: string | null;
  lastCalibrationDate: string;
  nextCalibrationDate: string;
  calibrationInterval: number;
  calibrationProvider?: string | null;
  status: KlsEquipmentStatus;
  documentUrl?: string | null;
  certificateUrl?: string | null;
  assignedToUserId?: string | null;
  assignedToUserName?: string | null;
  location?: string | null;
  notes?: string | null;
  id?: string;
}

export interface UpdateKlsEquipmentPayload {
  name: string;
  type: KlsEquipmentType;
  manufacturer?: string | null;
  model?: string | null;
  serialNumber?: string | null;
  lastCalibrationDate: string;
  nextCalibrationDate: string;
  calibrationInterval: number;
  calibrationProvider?: string | null;
  status: KlsEquipmentStatus;
  documentUrl?: string | null;
  certificateUrl?: string | null;
  assignedToUserId?: string | null;
  assignedToUserName?: string | null;
  location?: string | null;
  notes?: string | null;
}

export class KlsEquipmentApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<ApiResult<KlsEquipmentDto[]>> {
    return this.http.get<KlsEquipmentDto[]>("/api/kls-equipment");
  }

  get(id: string): Promise<ApiResult<KlsEquipmentDto>> {
    return this.http.get<KlsEquipmentDto>(`/api/kls-equipment/${encodeURIComponent(id)}`);
  }

  create(payload: CreateKlsEquipmentPayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/kls-equipment", { body: payload });
  }

  update(id: string, payload: UpdateKlsEquipmentPayload): Promise<ApiResult<KlsEquipmentDto>> {
    return this.http.put<KlsEquipmentDto>(`/api/kls-equipment/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<string>> {
    return this.http.delete<string>(`/api/kls-equipment/${encodeURIComponent(id)}`);
  }
}
